import React from 'react';
import { Link } from "react-router-dom";
import { APP_CONFIG } from '../../config/constants';

export function Footer() {
    return (
        <footer className="bg-gradient-to-b from-gray-50 to-white border-t border-gray-200 mt-20 overflow-x-hidden">
            <div className="container mx-auto py-16 px-4">
                {/* Grid com 3 colunas */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
                    {/* Sobre */}
                    <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                            <div className="w-8 h-8 bg-gradient-to-br from-brand-blue to-blue-600 rounded-lg flex items-center justify-center">
                                <svg className="w-5 h-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                </svg>
                            </div>
                            {APP_CONFIG.storeName}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed mb-4">
                            Plugins premium de alta qualidade para servidores Minecraft desde 2014. 
                            Transforme seu servidor com nossos produtos exclusivos.
                        </p>
                        <div className="flex gap-3">
                            <a href={APP_CONFIG.discordInviteUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-indigo-100 hover:bg-indigo-200 rounded-lg flex items-center justify-center transition-colors group">
                                <svg className="w-5 h-5 text-indigo-600 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0189 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Links Rápidos */}
                    <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-4">Links Rápidos</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link to="/plugins" className="text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-2 group">
                                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    Todos os Plugins
                                </Link>
                            </li>
                            <li>
                                <Link to="/conta" className="text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-2 group">
                                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    Minha Conta
                                </Link>
                            </li>
                            <li>
                                <Link to="/resgatar" className="text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-2 group">
                                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    Resgatar Gift Card
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Suporte */}
                    <div>
                        <h3 className="text-xl font-bold text-gray-900 mb-4">Suporte</h3>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <a href={APP_CONFIG.discordInviteUrl} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-2 group">
                                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    Discord
                                </a>
                            </li>
                            <li>
                                <Link to="/termos" className="text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-2 group">
                                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    Termos de Serviço
                                </Link>
                            </li>
                            <li>
                                <Link to="/privacidade" className="text-gray-600 hover:text-brand-blue transition-colors flex items-center gap-2 group">
                                    <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                    Política de Privacidade
                                </Link>
                            </li>
                        </ul>
                        
                        <div className="mt-6 p-4 bg-gradient-to-br from-brand-blue/5 to-blue-100/30 rounded-xl border border-brand-blue/20">
                            <p className="text-xs text-gray-600 mb-2 font-semibold">Precisa de ajuda?</p>
                            <p className="text-xs text-gray-500 leading-relaxed">
                                Entre em contato através do nosso servidor Discord para suporte rápido e eficiente.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-gray-200 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
                        <p className="text-gray-500 text-sm">
                            &copy; {new Date().getFullYear()} {APP_CONFIG.storeName}. Todos os direitos reservados.
                        </p>
                        <p className="text-gray-400 text-xs mt-2 md:mt-0">
                            Feito com <span className="text-red-500">❤</span> para a comunidade Minecraft
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}